import App from '@/models/App'

export default class ChatDocument extends App {
    static get entity() {
        return 'ChatDocuments'
    }
    static fields() {
        return {
            id: this.attr(''),
            chatMessageId: this.attr(''),
            userId: this.attr(''),
            name: this.attr(''),
            origin: this.attr(''),
            ext: this.attr(''),
            size: this.attr(''),
            isDownload: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            presignedUrl: this.attr(''),
        }
    }
    static apiConfig = {
        actions: {
            find(chatMessageId, chatDocumentId) {
                return this.get(
                    `${chatMessageId}/chat/documents/${chatDocumentId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
        },
    }
}
